export const BIOFUEL_BLEND = {
    petrol: 2.314,
    diesel: 0.4
}; // Multiplier
export const FOSSIL_ELEMENT = {
    petrol:  2.322,
    diesel: 2.673
}; // kg CO2/l
export const BATTERY_CO2_FACTOR = 83.5; // kg CO2-eq/kWh -- Average
// default ranges
export const FUEL_ECONOMY = {
    BEV: [12,22],
    ICE: [4,8]
}
export const DEFAULT_UTILITY_FACTOR = 0.3